// extracted by mini-css-extract-plugin
export var colourBase = "W6hkqcUIKJkWPQ0RDOPw";
export var colourDisabled = "SKg5sPAEUAiy9hjhpyBA";
export var colourInverted = "LyuhaCAC34vT1kbJGjeN";
export var colourNegative = "gWtZea1tiQN87qd1AyJv";
export var colourPositive = "N0_2kWw0pYPgese5jW7d";
export var colourSubdued = "LNueEvrDyyi0U9FNlhWX";
export var colourSubtle = "D1g0vdgPbT3FMDaPorxy";
export var colourUrgencyHigh = "NUZ4hnxuFeIEj1XqGvEq";
export var colourUrgencyMedium = "kLVP8wUuG1m5NhJsiqIN";
export var colourWarning = "wTFns_6lwUSkQtFWt2pA";
export var colourWhite = "JoMREgbc3f3IXpmhdi4i";